import { Patient } from '@dreryk/egabinet-patient-frontend-api';

import { BindingCreator, useTranslate, Validate } from '@dreryk/react-common';
import { Checkbox } from '@dreryk/react-components';

import { patientConsentsAndAuthorizationsTranslationKeys } from '../../../../translations';
import { MedicalConsentAndAuthorizationPrintBean } from '../../MedicalConsentAndAuthorizationsPrintModal';
import { CheckboxContent } from '../CheckboxContent';

import { StyledPatientConsentCheckbox, StyledPatientConsentCheckboxDetails } from './PatientConsentCheckbox.styled';

type PatientConsentCheckboxProps = {
   readonly register: BindingCreator<MedicalConsentAndAuthorizationPrintBean>;
   readonly patient: Patient;
};

const PatientConsentCheckbox = (props: PatientConsentCheckboxProps): JSX.Element => {
   const translate = useTranslate();

   const validate: Validate<MedicalConsentAndAuthorizationPrintBean> = (data, getValue) => {
      if (!data && !(getValue('confirmedAuthorizationsToPrint') as string[]).length) {
         return patientConsentsAndAuthorizationsTranslationKeys.printModal.chooseAtLeastOneToPrint;
      }
      return undefined;
   };

   return (
      <StyledPatientConsentCheckbox>
         <Checkbox
            controller={props.register('patientConsentToPrint', { validate: validate })}
            label={
               <CheckboxContent
                  firstName={props.patient.firstName!.asString()}
                  lastName={props.patient.lastName!.asString()}
               >
                  <StyledPatientConsentCheckboxDetails>
                     {translate(patientConsentsAndAuthorizationsTranslationKeys.printModal.patientConsent)}
                  </StyledPatientConsentCheckboxDetails>
               </CheckboxContent>
            }
            testId={'patientConsentToPrint'}
         />
      </StyledPatientConsentCheckbox>
   );
};

export { PatientConsentCheckbox };
